<div class="modal opened">
      <div class="modal-input-main">
        <div class="modal-header">
          <h2>{{title}}</h2>
        </div>
        <p class="txt" [innerHTML]="text">{{text}}</p>
        <div class="box_item">
          <label class="box-label" [hidden]="label == ''">{{label}}</label>
          <input [placeholder]="placeholder" [type]="inputType" [(ngModel)]="input">
        </div>
        <fieldset [ngClass]="{'two-buttons': secondButtonText != ''}">
          <core-helpers-forms-button
            [type]="'grey'"
            [text]="secondButtonText"
            (submit)="onSecondAction()"
            [hidden]="secondButtonText == ''"
          ></core-helpers-forms-button>
          <core-helpers-forms-button-white
            [disabled]="!isInputReady() || disabled"
            [text]="buttonText" 
            (submit)="onAction()"
          ></core-helpers-forms-button-white>
        </fieldset>
    </div>
</div>
